export enum EQrPollingStatusType {
    Joined = 0,
    NotJoined = 1,
}
export interface IAttendanceDate {
    id: string;
    classId: string;
    attendanceGuid: any;
    attendanceCreatedDate: Date;
    cratedByUserFullname: string;
    participantCount: number;
    totalCount: number;
}

export interface IClassData {
    label: string;
    value: string;
}

export interface IAttendanceUserData {
    userId?: string;
    userName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    lastLoginDate?: Date;
    trackingGuid?: string;
    avatarPath?: string;
    status?: number;
    totalCount?: number

}